import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_BEGIN,
  USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_SUCCESS,
  USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_FAILURE,
  USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function getProductByStripePriceId(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${config.apiRootUrl}/subscriptions/get-product-with-price-by-price-id/${args.priceId}`,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetProductByStripePriceIdError() {
  return {
    type: USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_DISMISS_ERROR,
  };
}

export function useGetProductByStripePriceId() {
  const dispatch = useDispatch();

  const { getProductByStripePriceIdPending, getProductByStripePriceIdError } =
    useSelector(
      (state) => ({
        getProductByStripePriceIdPending:
          state.user.getProductByStripePriceIdPending,
        getProductByStripePriceIdError:
          state.user.getProductByStripePriceIdError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(getProductByStripePriceId(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetProductByStripePriceIdError());
  }, [dispatch]);

  return {
    getProductByStripePriceId: boundAction,
    getProductByStripePriceIdPending,
    getProductByStripePriceIdError,
    dismissGetProductByStripePriceIdError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getProductByStripePriceIdPending: true,
        getProductByStripePriceIdError: null,
      };

    case USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_SUCCESS:
      // The request is success
      return {
        ...state,
        getProductByStripePriceIdPending: false,
        getProductByStripePriceIdError: null,
      };

    case USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_FAILURE:
      // The request is failed
      return {
        ...state,
        getProductByStripePriceIdPending: false,
        getProductByStripePriceIdError: action.data.error,
      };

    case USER_GET_PRODUCT_BY_STRIPE_PRICE_ID_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getProductByStripePriceIdError: null,
      };

    default:
      return state;
  }
}
